<template>
  <div>
    {{description}}
    <ams-search
      heading="Asset Links"
      :ams_type="ams_type"
      :ams_fields="ams_fields"
      @searchFor="searchSelection"
    ></ams-search>
    <b-row>
      <b-col b-col md="4" class="my-1">
        Total {{totalRows}}
      </b-col>
      <b-col b-col md="4" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          aria-controls="table-transition-example"
          pills
          align="fill"
          class="my-1"
          size="sm"
        ></b-pagination>
      </b-col>
      <b-col md="4" class="my-1">
        <b-button variant="outline-primary"
          size="sm" @click="addEntry"
          v-b-tooltip.hover.right title="Add Entry"
        >
          <b-icon-plus-circle-fill> aria-label="Add Entry"></b-icon-plus-circle-fill>
        </b-button>
      </b-col>
    </b-row>
    <b-card bg-variant="light">
      <b-card-group deck>
        <div v-for="(item) in items" :key="item.id" class="col-xs-6 col-sm-4 col-md-3">
          <b-button-group>
            <b-button v-show="isAdminPath"
              size="sm"
              variant="primary" 
              class="mb-2"
              v-b-tooltip.hover.top title="Go Update"
              @click="navigateToUpdate(item)"
            >
              <b-icon-triangle aria-label="Update"></b-icon-triangle>
            </b-button>
            <b-button size="sm"
              variant="primary"
              class="mb-2"
              v-b-tooltip.hover.down title="Go View"
              @click="navigateToShow(item)"
            >
              <b-icon-asterisk aria-label="View"></b-icon-asterisk>
            </b-button>
          </b-button-group>
          <asset-image-link-card :data_item="item" :image_item="dataImage(item)" :product_item="dataProduct(item)"></asset-image-link-card>
        </div>
      </b-card-group>
    </b-card>
    <b-row>
      <b-col b-col md="4" class="my-1">
        Total {{totalRows}}
      </b-col>
      <b-col b-col md="4" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          aria-controls="table-transition-example"
          pills
          align="fill"
          class="my-1"
          size="sm"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {http_v1} from '@/axios'
import {ADMIN_PATH, ITEM_IMAGE_ASSOCIATIONS, COLLECTION_IMAGES, PRODUCT_ITEMS, amsApiResourcePath} from '@/ams_route.js'
import AmsSearch from './AmsSearch.vue'
import AssetImageLinkCard from './AssetImageLinkCard.vue'
import {
  BIconAsterisk,
  BIconTriangle,
  BIconPlusCircleFill
} from 'bootstrap-vue'

export default {
  components: {
    AmsSearch,
    BIconAsterisk,
    BIconTriangle,
    BIconPlusCircleFill,
    AssetImageLinkCard
  },
  props: {
    filtering: {
      Type: Object
    },
    api_path: {
      Type: String
    },
    description: {
      Type: String
    },
    ams_template: {
      type: Object
    }
  },
  data () {
    return {
      ams_type: ITEM_IMAGE_ASSOCIATIONS,
      reroute_name: 'AssetImageLinkCreateScreen',
      link: "/" + this.ams_type + "/create",
      totalRows: 0,
      currentPage: 1,
      perPage: 0,
      items: [],
      included: [],
      ams_fields: [
        { 
          key: 'attributes.item-image-rating',
          label: 'Asset Image Rating',
          sortable: true,
          filterable: true,
          class: 'text-left',
          sortDirection: 'asc' 
        },
        { 
          key: 'attributes.comment',
          label: 'Rating Comment',
          sortable: true,
          filterable: true,
          class: 'text-center',
          sortDirection: 'asc' 
        }
      ],
      search_params: undefined
    }
  },
  computed: {
    isAdminPath() {
      return this.apiPath() == ADMIN_PATH
    }
  },
  methods: {
    dataImage(item) {
      let included_obj = this.included.find( 
        el =>  
        el.type === COLLECTION_IMAGES && el.id === item.attributes['collection-image-id']
      )
      return included_obj
    },
    dataProduct(item) {
      let included_obj = this.included.find( 
        el =>  
        el.type === PRODUCT_ITEMS && el.id === item.attributes['product-item-id']
      )
      return included_obj
    },
    apiPath () {
      return this.paramApiPath() || ADMIN_PATH
    },
    paramApiPath() {
      // Note $route and $router are not the same
      return this.api_path || this.$route.query?.api_path
    },
    apiResourcePath() {
      return amsApiResourcePath(this.apiPath(), ITEM_IMAGE_ASSOCIATIONS)
    },
    addEntry() {
      if(this.reroute_name) {
        this.$router.push( {
          name: this.reroute_name,
          params: {
            ams_template: this.ams_template,
            api_path: this.api_path
          },
          query: { api_path: this.api_path }
        })
      }
      else {
        this.$router.push( {
          path: this.link
        })
      }
    },
    searchSelection(searchOptions) {
       this.search_params = searchOptions
       this.callApi()
    },
    callApi () {
      http_v1.get (
        this.apiResourcePath(), {
          params: {
            page: this.currentPage,
            ... this.filtering,
            ... this.search_params
          }
        }
      ).then(response => {
        if(response.status == 200) {
          this.totalRows = response.headers.total
          this.perPage = response.headers['per-page']
          this.items = response.data.data
          this.included = response.data.included
        }
        else {
          window.console.log(response.status)
        }
      }).catch(error => {
        this.items = []
        this.totalRows = 0
        if( error.response && error.response.data) {
          var message = error.response.data.message || JSON.stringify(error.response.data)
          if (error.response.status === 500 ) message = "500 Server Error"
          window.console.log(message)
          this.$bvToast.toast(message, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true
          })
        }
      })
    },
    navigateToShow(data_item) {
      let nav = {
        name: 'AssetImageLinkShowScreen', 
        params: {
          id: data_item.id,
          api_path: this.api_path
        },
        query: { api_path: this.paramApiPath() }
      }
      this.$router.push(nav)
    },
    navigateToUpdate(data_item) {
      let nav = {
        name: 'AssetImageLinkUpdateScreen', 
        params: {
          id: data_item.id
        }
      }
      this.$router.push(nav)
    }
  },
  watch: {
    currentPage() {
      this.callApi()
    }
  },
  mounted() {
    this.callApi()
  }
}
</script>
